import { useAuthenticatedApiCall } from 'services/api.service';
import { api } from 'config/api';
import { useCallback } from 'react';

export function useActivateTenant() {
  const ACTIVATION_ENDPOINT = '/tenant';

  const { makeAuthenticatedApiCall } = useAuthenticatedApiCall({
    baseURL: `${api.API_URL}${ACTIVATION_ENDPOINT}`,
  });

  const startActivation = () =>
    makeAuthenticatedApiCall<string>({
      url: `activation`,
      method: 'put',
    });

  return useCallback(startActivation, []);
}
